<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center margin612">
                <div class="breadcrumbnew">
                    <span @click="$router.push('/auction/create')">Auction</span>
                    <a>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <button class="btn btn-new-danger btn-wide px-6 mr-4" @click="showDeleteAuction" :disabled="auction_form_selected.length < 1 || disableDelete == true || deleteauctionmodal == true">- Delete</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-2" @click="showFilters()"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    <button class="btn btn-new-green btn-wide px-6" @click="$router.push('/auction/create')">+ Create New</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li class="tab-current">
                                <a href="javascript:;" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex ml-4" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_auction_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="search_auction_key" @input="uncheckSelected(), getListViewData()" placeholder="Search by Auction Name" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </div>
            <!-- Table Section -->
            <div class="table-block overflow-x-auto pt-10" style="background-color:#fff;border-top-right-radius:5px;overflow-y: scroll;">
                <table class="auction-list-table w-100">
                    <thead style="width: 100% !important">
                        <tr>
                            <th style="width: 2% !important" v-if="auction_data.length == 0"></th>
                            <th v-else style="width: 10px !important;padding: 13px 18px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="check_all" @change="checkAll" name="select_all" />
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th style="width: 15% !important">
                                <span v-on:click="setPasskey('auction_name')" class="cursor-th">
                                    <span class="pointer"><img src="/static/images/double-arrow.svg" alt="" width="15px"></span>
                                    <!-- <span v-if="passed_key.key=='auction_name' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'auction_name'}" class="sorting-icon">
                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                    </span>
                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'auction_name'}" class="sorting-icon">
                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                    </span> -->
                                    AUCTION NAME
                                </span>
                            </th>
                            <th style="width: 8% !important">NO. OF ITEMS</th>
                            <th style="width: 15% !important">
                                <span v-on:click="setPasskey('auction_start_time')" class="cursor-th">
                                    AUCTION OPENING DATE
                                    <span v-if="passed_key.key=='auction_start_time' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'auction_start_time'}" class="sorting-icon">
                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                    </span>
                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'auction_start_time'}" class="sorting-icon">
                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                    </span>
                                </span>
                            </th>
                            <th style="width: 15% !important">
                                <span v-on:click="setPasskey('auction_end_time')" class="cursor-th">
                                    AUCTION CLOSING DATE
                                    <span v-if="passed_key.key=='auction_end_time' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'auction_end_time'}" class="sorting-icon">
                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                    </span>
                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'auction_end_time'}" class="sorting-icon">
                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                    </span>
                                </span>
                            </th>
                            <th style="width: 35% !important">HOST URL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajaxCallInProgress">
                            <td colspan="9">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && auction_data.length == 0" class="text-center font-weight-bold" style="height: 400px !important;">
                            <td colspan="15">
                                <img src="/static/images/territory-sales.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center">No Auction added!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(auction, index) in auction_data" :key="index">
                            <td style="width: 10px !important;padding: 13px 18px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="auction.checked" @change="selectAuction($event, auction, index)"  name="select_one" />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td class="text-secondary pointer text-truncate" :title="auction.auction_name" @click="goToBidderListview(auction)">{{auction.auction_name}}</td>
                            <td>{{auction.table_details.no_of_tables}}</td>
                            <td>{{auction.auction_start_time}}</td>
                            <td>{{auction.auction_end_time}}</td>
                            <td class="w-1 text-truncate justify-content-between align-items-center d-flex">
                                <div class="table-action-status text-truncate max-width" :title="auction.table_details.host_url">
                                    <a :href='auction.table_details.host_url' target="_blank" style="text-decoration: none !important;">{{auction.table_details.host_url}}</a>
                                </div>
                                <div class="table-action-btns" style="text-align: right !important;">
                                    <el-tooltip class="item" effect="dark" content="View" placement="top">
                                        <i class="icon icon-eye fs-18 text-secondary mr-2 icon-custom-style pointer" @click="viewAuction(auction.id)"></i>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                        <i class="icon icon-pencil fs-18 text-secondary mr-2 icon-custom-style pointer" @click="editAuction(auction.id)"></i>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="Copy" placement="top">
                                        <span class="pointer pl-2"><img src="/static/images/Copy.svg" alt="" width="16px" height="16px" style="margin-top: -7px !important;"></span>
                                        <!-- <i class="icon icon-copy fs-20 text-secondary icon-custom-style pointer"></i> -->
                                    </el-tooltip>
                                </div>
                            </td>
                        </tr> 
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="auction_data.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                     :options="pageLimit" :close-on-select="true" v-model.number="limit"
                     :max-height="210" :allow-empty="false" :searchable="false"
                     open-direction="top" :show-labels="false" placeholder=""
                     style="width: 4.2em !important;padding-right: 10px!important;">
                 </multiselect>
     
                 <span class="page-info pr-6 pl-0 fw-500 text-dark font-size-small">Per page</span>
                 <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                     <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                         <i class="icon-chevron-double-left"></i>
                     </el-tooltip>
                 </button>
                 <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                     <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                         <i class="icon icon-chevron-left"></i>
                     </el-tooltip>
                 </button>
                 <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                 <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                     <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                         <i class="icon icon-chevron-right"></i>
                     </el-tooltip>
                 </button>
                 <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                     <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                         <i class="icon-chevron-double-right"></i>
                     </el-tooltip>
                 </button>
             </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <div v-if="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <auction-filter-data :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></auction-filter-data>
            </div>
        </div>
        <delete-auction modal_name="deleteAuction" @deleteAuctions="deleteAuctions" :auction_form_selected="auction_form_selected" @cancelDelete="cancelDelete" v-if="deleteauctionmodal"></delete-auction>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';
import auctionList from "../mixins/auction.js"
import { HalfCircleSpinner } from "epic-spinners";
import DeleteAuction from "./DeleteAuction";
import AuctionFilterData  from './auctionFilterData'
import { debounce } from 'lodash';
export default {
    mixins: [auctionList],
    components: {
        HalfCircleSpinner,
        SweetModal,
        DeleteAuction,
        AuctionFilterData},
    data(){
        return {
            disableDelete: false,
            deleteauctionmodal: false,
            search_auction_key: "",
            select_all_auction: false,
            temp_total: 0,
            skip: 0,
            limit: 10,
            skip_temp: 0,
            total: 0,
            auction_data:[],
            pageLimit: [],
            ajaxCallInProgress: false,
            auction_form_selected: [],
            checked: false,
            check_all: false,
            warning_msg: '',
            success_msg: '',
            display_filters: false,
            hide_filters: false,
            passed_key: {
                key: 'auction_name',
                value: 1
            },
            filterData: {
                auction_name: [],
                auction_opening_date: "",
                auction_closing_date: ""

            },
            showfilterData: {
                auction_name: [],
                auction_opening_date: "",
                auction_closing_date: ""
            }
        }
    },
    methods: {
        //To clear search field
        clearSearch(){
            this.search_auction_key = "";
            this.$refs.searchInput.focus();
            this.uncheckSelected(); 
            this.getListViewData();
        },
        UpdateByFilter(params){
            this.skip = 0
            this.limit = 10
            this.showfilterData = {
                auction_name: params.value1.auction_name,
                auction_opening_date:params.value1.auction_opening_date,
                auction_closing_date:params.value1.auction_closing_date,
            }
            this.filterData = {
                // company_name: params.value1.company_name == null || params.value1.company_name == '' ? [] : [params.value1.company_name] ,
                // contact_name:params.value1.contact_name,
                auction_name:params.value1.auction_name,
                auction_opening_date:params.value1.auction_opening_date,
                auction_closing_date: params.value1.auction_closing_date
            }
            this.getAuction();
        },
        //Redirects to bidder list view page
        goToBidderListview(auction){
            this.$router.push('/auction/bidderlistview/'+auction.id)
        },
        setPasskey: function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            this.getAuction()
        },
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        //Redirects to auction view page
        viewAuction(id) {
            this.$router.push('/auction/view/'+ id);
        },
        //Redirects to auction edit page
        editAuction(id) {
            this.$router.push('/auction/edit/'+ id);
        },
        uncheckSelected(){
            this.auction_form_selected = [];
            this.check_all = false;
        },
        cancelDelete(){
            this.deleteauctionmodal = false;
        },
        deleteAuctions(){
            this.deleteAuctionsData();
        },
        //OPens delete confirmation popup
        showDeleteAuction() {
            this.deleteauctionmodal = true
            setTimeout(() => {
                this.$modal.show('deleteAuction')
            }, 500)
        },
        //API call to delete selected auctions
        async deleteAuctionsData() {
            this.disableDelete = true;
            try {
                let param = {
                    "auction_id's": this.auction_form_selected
                };
                let response = await this.deleteAuction(param);
                this.deleteauctionmodal = false;
                this.success_msg = response.message;
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.auction_form_selected = [];
                    this.disableDelete = false;
                    this.$refs.success_modal.close();
                    this.getAuction();
                }, 3000);
            }
            catch(error) {
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableDelete = false;
                    this.$refs.warning_modal.close();
                    this.getAuction();
                }, 3000);
            }
        },
        //Selects all checkbox function
        checkAll(event) {
            if(event.target.checked === true){
                this.auction_data.forEach((el_auction, index) => {
                    if(this.auction_data[index].checked == false){
                        this.auction_data[index].checked = true;
                        this.auction_form_selected.push(el_auction.id)
                    }
                })
            } else {
                this.auction_data.forEach((el_auction, index) => {
                    this.auction_data[index].checked = false;
                })
                this.auction_data.forEach((auction_list, auction_list_index) => {
                    this.auction_form_selected.forEach((selected_auction, selected_auction_index) => {
                        if(auction_list.id == selected_auction){
                            this.auction_form_selected.splice(selected_auction_index, 1)
                        }
                    })
                })
            }
        },
        //Select single auction checkbox function
        selectAuction(event, auction, index) {
            if(event.target.checked){
                this.auction_form_selected.push(auction.id)
            } else {
                this.auction_form_selected.forEach((selected_auction, selected_auction_index) => {
                    if(selected_auction === auction.id){
                        this.auction_form_selected.splice(selected_auction_index, 1)
                    }
                })
            }
            if(this.auction_data.every(x => x.checked == true)){
                this.check_all = true;
            } else {
                this.check_all = false;
            }
        },
        //API call to get all existing auctions data
        async getAuction() {
            this.ajaxCallInProgress = true
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: this.search_auction_key,
                    sort_key: this.passed_key.key,
                    sort_value: this.passed_key.value,
                    filter: this.filterData
                };
                let response = await this.getAuctionsList(params)
                this.auction_data = response.data.auction_data
                if(this.auction_data.length != 0){
                    this.auction_data.forEach((auction, index) => {
                        this.auction_data[index].checked = false;
                        if(this.auction_form_selected.length){
                            this.auction_form_selected.forEach((el_selected, el_selected_index) => {
                                if(el_selected === auction.id){
                                    this.auction_data[index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.auction_data.every(x => x.checked == true)){
                        this.check_all = true;
                    } else {
                        this.check_all = false;
                    }
                }
                this.total = response.total_length;
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        //Pagination methods
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getAuction();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getAuction();
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.getAuction();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getAuction();
        },
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.getAuction();
    },
    created() {
        this.getListViewData = debounce(this.getAuction, 500)
    },
    watch: {
        limit: function(){
            this.getAuction();
        }
    },
}
</script>
<style scoped>
    .auction-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .auction-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .auction-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .auction-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .auction-list-table tbody tr td span img {
        width: 16px !important;
        height: 16px !important;
        margin-left: -10px;
    }
    .table-action-btns,
    .auction-list-table tbody tr:hover .table-action-status {
        display: block;
    }
    .table-action-status,
    .auction-list-table tbody tr:hover .table-action-btns {
        display: block;
    }
    .scm-filters{
        height: fit-content !important;
        padding-bottom: 20px !important;
        overflow: auto !important;
    }
    .hide-arrow {
        visibility: hidden;
    }
    .sorting-icon {
        visibility: visible !important;
        cursor: pointer;
    }
    .max-width{
        max-width: 300px !important;
    }
    .text-truncate{
        max-width: 350px !important;
        width: 350px !important;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 613px) {
        .margin612{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Auction/AuctionListView.vue